module.exports = __webpack_public_path__ + "static/media/desk-illustration.94acdeff.svg";